import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const StepWrapper = styled.div<{ txtColor: COLORS, bgColor: COLORS }>`
    flex-direction: column;
    flex-wrap: nowrap;
    max-width: 358px;
    padding: 30px 40px;
    color: ${p => p.txtColor};
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${p => p.bgColor};
    overflow: hidden;

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 32px 40px;
    }
`;

export const StepNumber = styled.p`
    ${FONTS.H0};
    color: inherit;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H1};
    }
`;

export const StepInfo = styled.p`
    ${FONTS.H4};
    color: inherit;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H5};
    }
`;
